import printComponent from './items.component';

let printModule = angular.module('branchMgmtPrintStopReceipt', [
])
    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/branchManagement.items');

        $stateProvider
            .state('branchMgmtPrintStopReceipt', {
                url: '/print-stop-receipt',
                component: 'branchMgmtPrintStopReceipt',
                data: {
                    requireLogin: true,
                    requireACL: 'branch_mgmt_items.all'
                },
            })
    })

    .component('branchMgmtPrintStopReceipt', printComponent)

    .name;

export default printModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/items/print/index.js